import React, { FunctionComponent } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LogoutButton from './auth/logout-button';
import c4clogo from '../images/image001.png';

const Header: FunctionComponent = () => {
  const { pathname } = useLocation();
  const HOME = '/';
  const DASHBOARD = '/dashboard';

  return (
    <section className="header">
      <div className="logo">
        <img
          className="logo__image"
          style={{ objectFit: 'contain' }}
          alt={'logo'}
          src={c4clogo}
        />
      </div>
      <nav className="page-nav">
        {pathname === HOME ?
          <Link className="page-nav__button__active" to={HOME} aria-current="page">Overview</Link> :
          <Link className="page-nav__button" to={HOME}>Overview</Link>
        }
        {pathname === DASHBOARD ?
          <Link className="page-nav__button__active" to={DASHBOARD} aria-current="page">Dashboard</Link> :
          <Link className="page-nav__button" to={DASHBOARD}>Dashboard</Link>
        }
      </nav>
      <nav className="user-nav">
        <div className="user-nav__user">
          <LogoutButton />
        </div>
      </nav>
    </section>
  );
};

export default Header;
